import { trackLastTransactionsAmplitudeEvent } from '@/modules/transaction/helpers/track-amplitude-event';

export function trackChangePaginationClick(page: number) {
  trackLastTransactionsAmplitudeEvent({
    event_type: 'Click',
    event_name: 'click_account',
    page_screen_section: 'body',
    event_target: page
  });
}
